import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import { Box, Typography } from '@material-ui/core';
import OpacityIcon from '@material-ui/icons/Opacity';
import { useTranslation } from 'react-i18next';
import { styles } from './style';
import { makeStyles } from '@material-ui/core/styles';
import RRIMap from './RriMap/RRIMap';
import RRISidebar from './RriMap/RRISidebar/RRISidebar';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import orderBy from 'lodash/orderBy';
import dayjs from 'dayjs';
import RRIRightSidebar from './RriMap/RRISidebar/RRIRightSidebar';


const useStyles = makeStyles(styles);
const initPath = process.env.REACT_APP_THAIWATER_URL;
const initFewsUrl = process.env.REACT_APP_FEWS_URL;
const API = process.env.REACT_APP_API_URL;

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [map, setMap] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mainRiver, setMainRiver] = useState(false);
  const [basin, setBasin] = useState(false);
  const [waterLevel, setWaterLevel] = useState(false);
  const [datas, setDatas] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ header: '', content: null });
  const [forecastDay, setForecastDay] = useState(1);
  const [rainfallEnabled, setRainfallEnabled] = useState(false);
  const [dataRainfall24, setDataRainfall24] = useState([]);
  const [datasRainTodayMarker, setDatasRainTodayMarker] = useState([]);
  const [datasRainYesterday, setDatasRainYesterday] = useState([]);
  const [datasRain3day, setDatasRain3day] = useState([]);
  const [datasRain7day, setDatasRain7day] = useState([]);
  const [datasRain15Day, setDatasRain15Day] = useState([]);
  const [datasLargeDam, setDatasLargeDam] = useState([]);
  const [datasMediumDam, setDatasMediumDam] = useState([]);
  const [largeDamEnabled, setLargeDamEnabled] = useState(false);
  const [mediumDamEnabled, setMediumDamEnabled] = useState(false);
  const [rriStationEnabled, setRriStationEnabled] = useState(true);
  const [rriStations, setRriStations] = useState([]);
  const [rriTifUrl, setRriTifUrl] = useState('');
  const [mapInstance, setMapInstance] = useState(null);
  const [rriReservoirEnabled, setRriReservoirEnabled] = useState(true);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [selectedStation, setSelectedStation] = useState(null);
  const [rriLatestQr, setRriLatestQr] = useState({});
  const [rriTifEnabled, setRriTifEnabled] = useState(true);
  const [rriThresholds, setRriThresholds] = useState({});
  const [statusFilter, setStatusFilter] = useState(0);
  const [datasRain30Day, setDatasRain30Day] = useState([]);

  const handleSetMap = (m) => {
    setMap(m);
    setMapInstance(m);
  };

  const forecastDayToType = {
    1: 'rainfallYesterday',
    2: 'rainfallToday',
    3: 'rainfall24h',
    4: 'rainfall3day',
    5: 'rainfall7day',
    6: 'rainfall15day',
    7: 'rainfall30day',
  };

  const handleModalOpen = (params) => {
    setModalContent(params);
    setModalOpen(true);
  };
  const handleModalClose = () => setModalOpen(false);

  const handleMarkerClick = (data) => {
    setSelectedStation(data);
    setRightSidebarOpen(true);
  };

  useEffect(() => {
    if (map) {
      const timer = setTimeout(() => {
        map.invalidateSize();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [sidebarOpen, map]);

    useEffect(() => {
      fetch(`${initPath}/proxy/csv.php?file=${initFewsUrl}/model-output/data_portal/metadata/hii_waterlevel.csv`)
        .then(res => res.text())
        .then(result => {
          const rawData = Papa.parse(result).data.slice(1);
          setDatas(rawData);
        })
        .catch(err => console.error('fetch waterlevel error:', err));

      fetch(`${API}/public/rain_24h`)
        .then(res => res.json())
        .then(result => setDataRainfall24(orderBy(result.data, ['rain_24h'], ['desc']).filter(d => d.rain_24h > 0)));

      fetch(`${API}/public/rain_today`)
        .then(res => res.json())
        .then(result => setDatasRainTodayMarker(orderBy(result.data, ['rainfall_value'], ['desc']).filter(d => d.rainfall_value > 0)));

      fetch(`${API}/public/rain_yesterday`)
        .then(res => res.json())
        .then(result => setDatasRainYesterday(orderBy(result.data, ['rainfall_value'], ['desc']).filter(d => d.rainfall_value > 0)));

      fetch(`${API}/provinces/rain3d`)
        .then(res => res.json())
        .then(result => setDatasRain3day(orderBy(result.data, ['rain_3d'], ['desc']).filter(d => d.rain_3d > 0)));

      fetch(`${API}/provinces/rain7d`)
        .then(res => res.json())
        .then(result => setDatasRain7day(result.data.filter(d => d.rain_7d > 0)));

      fetch(`${API}/provinces/rain15d`)
        .then(res => res.json())
        .then(result => setDatasRain15Day(orderBy(result.data, ['rain_15d'], ['desc']).filter(d => d.rain_15d >= 0.1)));

      fetch(`${API}/public/rain_monthly`)
        .then(res => res.json())
        .then(result => {
          if (!result.data) return;
          const sorted = orderBy(result.data, ['rainfall_value'], ['desc']);
          setDatasRain30Day(sorted.filter(d => d.rainfall_value >= 0.1));
        })
        .catch(err => console.error('rain_monthly error:', err));

      fetch(`${API}/analyst/dam`)
        .then(res => res.json())
        .then(result => {
          const currentDateTime = new Date();
          const last24hrs = new Date().setDate(currentDateTime.getDate() - 2);

          const largeSorted = orderBy(result.data.dam_daily, ['dam_storage_percent'], ['desc']);
          setDatasLargeDam(largeSorted.filter(d => {
            const time = new Date(d.dam_date).getTime();
            return (last24hrs < time && d.agency.id === 12) || [231, 319, 320].includes(d.dam.id);
          }));

          const mediumSorted = orderBy(result.data.dam_medium, [o => o.dam_storage_percent || ''], ['desc']);
          setDatasMediumDam(mediumSorted.filter(d => {
            const time = new Date(d.dam_date).getTime();
            return last24hrs < time || d.dam_date === '1970-01-01';
          }));
        })
        .catch(err => console.error('fetch dam error:', err));

      fetch(`${process.env.REACT_APP_LIVE_HII}/product/latest/rri/metadata/json/station_rri_final.geojson`)
        .then(res => res.json())
        .then(data => setRriStations(data.features.filter(f => f.geometry !== null)))
        .catch(err => console.error('fetch rri station error:', err));
    }, []);

    useEffect(() => {
      const runDate = dayjs().format('YYYYMMDD') + '07';
      const DatapathDate = dayjs().subtract(1, 'day').format('YYYYMMDD') + '07';
      const forecastDate = dayjs().add(forecastDay - 1, 'day').format('YYYYMMDD') + '07';
      const url = `${process.env.REACT_APP_LIVE_HII}/product/latest/rri/qr/THA_qr_${DatapathDate}_${forecastDate}.tif`;
      setRriTifUrl(url);
    }, [forecastDay]);

    useEffect(() => {
      if (!rriStations || rriStations.length === 0) return;

      const controller = new AbortController();
      const signal = controller.signal; 

      const stations = rriStations
        .filter(f => f.properties?.station || f.properties?.reservoir)
        .map(f => f.properties.station || f.properties.reservoir);

      const fetchInBatches = async (items, batchSize = 20) => {
        const result = {};
        const now = new Date(); // ← เพิ่ม

        for (let i = 0; i < items.length; i += batchSize) {
          if (signal.aborted) break;
          const batch = items.slice(i, i + batchSize);
          await Promise.all(batch.map(async (station) => {
            try {
              const url = `${process.env.REACT_APP_LIVE_HII}/product/latest/rri/station/${station}.csv`;
              const res = await fetch(url, { signal });
              const text = await res.text();
              const lines = text.trim().split('\n')
                .filter(line => !line.startsWith('datetime') && line.trim() !== '');

              let closestQr = null;
              let closestDiff = Infinity;

              lines.forEach(line => {
                const cols = line.split(',');
                const dt = new Date(cols[0]);
                const qr = parseFloat(cols[2]);
                if (isNaN(dt.getTime()) || isNaN(qr)) return;
                const diff = now - dt;
                if (diff >= 0 && diff < closestDiff) {
                  closestDiff = diff;
                  closestQr = qr;
                }
              });

              if (closestQr !== null) result[station] = closestQr;
            } catch {}
          }));
        }
        return result;
      };

      fetchInBatches(stations, 20).then(result => {
        if (!signal.aborted) setRriLatestQr(result);
      });

      return () => controller.abort();

    }, [rriStations]);

    useEffect(() => {
      fetch(`${process.env.REACT_APP_LIVE_HII}/product/latest/rri/metadata/csv/rri_station_coordinate_qr.csv`)
        .then(res => res.text())
        .then(text => {
          const lines = text.trim().split('\n').slice(1); // skip header
          const map = {};
          lines.forEach(line => {
            const [order, station, lat, lon, lowest, alarm, warning, critical] = line.split(',');
            if (station) {
              map[station.trim()] = {
                alarm:    parseFloat(alarm)    || null,
                warning:  parseFloat(warning)  || null,
                critical: parseFloat(critical) || null,
              };
            }
          });
          setRriThresholds(map);
        })
        .catch(err => console.error('fetch threshold error:', err));
    }, []);

    const getStationStatus = (station) => {
      const qr = rriLatestQr[station];
      const th = rriThresholds[station];
      if (qr == null || !th) return 'normal';
      if (th.critical != null && qr >= th.critical) return 'critical';
      if (th.alarm    != null && qr >= th.alarm)    return 'alarm';
      return 'normal';
    };

    const visibleRriStations = React.useMemo(() => {
      if (statusFilter === 0) return rriStations;
      return rriStations.filter(f => {
        const name = f.properties?.station || f.properties?.reservoir;
        const status = getStationStatus(name);
        if (statusFilter === 1) return status === 'alarm';
        if (statusFilter === 2) return status === 'critical';
        return true;
      });
    }, [rriStations, rriLatestQr, rriThresholds, statusFilter]);

  return (
    <Box>
      {/* Header */}
      <Box display="flex" alignItems="center" mb={2}>
        <Box
          display="flex"
          className={classes.shapeCircle}
          alignItems="center"
          justifyContent="center"
        >
          <OpacityIcon style={{ color: '#fff' }} />
        </Box>
        <Box p={1}>
          <Typography variant="h6" className={classes.titlePage}>
            {t('ระบบคาดการณ์น้ำท่าด้วยแบบจำลอง RRI')}
          </Typography>
        </Box>
      </Box>

      {/* Sidebar + Map */}
        <Box mt={2} mb={2} display="flex"
          style={{
            width: '100%',
            height: 'calc(100vh - 150px)',
            overflow: 'hidden',
          }}
        >
        <RRISidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          mainRiver={mainRiver} 
          setMainRiver={setMainRiver}
          basin={basin} 
          setBasin={setBasin}
          waterLevel={waterLevel}
          setWaterLevel={setWaterLevel}
          rainfallEnabled={rainfallEnabled}
          setRainfallEnabled={setRainfallEnabled}
          forecastDay={forecastDay}
          setForecastDay={setForecastDay}
          largeDamEnabled={largeDamEnabled}
          setLargeDamEnabled={setLargeDamEnabled}
          mediumDamEnabled={mediumDamEnabled}
          setMediumDamEnabled={setMediumDamEnabled}
          rriStationEnabled={rriStationEnabled}
          setRriStationEnabled={setRriStationEnabled}
          rriReservoirEnabled={rriReservoirEnabled}
          setRriReservoirEnabled={setRriReservoirEnabled}
          rriStations={rriStations}
          onStationSelect={(lat, lng) => {
            if (mapInstance) {
              mapInstance.setView([lat, lng], 12);
            }
          }}
          rriTifEnabled={rriTifEnabled}
          setRriTifEnabled={setRriTifEnabled}
          rriLatestQr={rriLatestQr}
          rriThresholds={rriThresholds}
          onStatusChange={setStatusFilter}
        />

        <Box
          flex={1}
          style={{
            position: 'relative',
            overflow: 'hidden',
            height: '100%',
            zIndex: 0, 
          }}
        >
          <RRIMap
            location={[13.0, 101.0]}
            zoom={6}
            handleSetMap={handleSetMap}
            sidebarOpen={sidebarOpen}
            onOpenSidebar={() => setSidebarOpen(true)}
            mainRiver={mainRiver}
            layers={{ basin }}
            datas={datas}
            waterLevel={waterLevel}
            markers={[]}
            handleModalOpen={handleModalOpen}
            rainfallEnabled={rainfallEnabled}
            rainfallType={forecastDayToType[forecastDay]}
            datasRainTodayMarker={datasRainTodayMarker}
            datasRainYesterday={datasRainYesterday}
            dataRainfall24={dataRainfall24}
            datasRain3day={datasRain3day}
            datasRain7day={datasRain7day}
            datasRain15Day={datasRain15Day}
            datasLargeDam={datasLargeDam}
            datasMediumDam={datasMediumDam}
            largeDamEnabled={largeDamEnabled}
            mediumDamEnabled={mediumDamEnabled}
            rriStationEnabled={rriStationEnabled}
            rriTifUrl={rriTifUrl}
            rriReservoirEnabled={rriReservoirEnabled}
            onMarkerClick={handleMarkerClick}
            rriLatestQr={rriLatestQr}
            rriTifEnabled={rriTifEnabled}
            rriStations={visibleRriStations}
            datasRain30Day={datasRain30Day}
          />
        </Box>
          <RRIRightSidebar
            open={rightSidebarOpen}
            onClose={() => setRightSidebarOpen(false)}
            selected={selectedStation}
          />
      </Box>

      <Dialog open={modalOpen} onClose={handleModalClose} maxWidth="md" fullWidth container={() => document.fullscreenElement || document.body} style={{ zIndex: 999999 }}>
        <DialogTitle>
          {modalContent.header}
          <IconButton onClick={handleModalClose} style={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {modalContent.content}
        </DialogContent>
      </Dialog>
    </Box>
  );
}